import React, {RefObject, useRef} from "react"
import {findDOMNode} from "react-dom"

import ItemModelV2 from "../../../../../../../model2/item2/item-model"
import FieldProto from "../../../../../../proto/field-proto"
import TaskStatusSelectorPopover from "../../../../../../../gd-ui/select-status/task_v2/popover"
import PopoverPosition from "../../../../../../../gd-components/gd-popover/popover-position"
import TaskStatusManager from "../../../../../../../gd/manager/task-status-manager"

type Props = {
    className?      : string
    style?          : any

    listItem        : ItemModelV2
    field           : FieldProto

    showPopover     : boolean

    onMouseEnter    : callback
    onMouseLeave    : callback
    onClick         : func
    onValueChange   : callback
    onHidePopover   : func
}

// const debug = "FieldTaskStatus_TableCellCalculated_Hovered"
const debug = false

export default function FieldTaskStatus_TableCellCalculated_Hovered(props: Props) {

    const refSelf: RefObject<any> = useRef()

    // const calculatedValues: ItemModelV2_CalculatedValues | undefined = props.listItem.calculated.data[props.field.fieldId as keyof {}]
    // const ownValue = calculatedValues?.own || props.field.getViewValue(props.listItem.item)

    const status = gd.session.statuses.get(props.listItem.task.statusId)
    if (!status) {
        return null
    }

    const _workflow = TaskStatusManager.getWorkflow(props.listItem.task)

    return (
        <div ref            = {refSelf}
             className      = "cell-flex is-hovered"
             style          = {props.style}
             onMouseEnter   = {props.onMouseEnter}
             onMouseLeave   = {props.onMouseLeave}>
            <div className="ui5-field-editable size-small is-hovered w-100-percent h-100-percent"
                 onClick={props.onClick}>

                <div className={Classes('ui5-status-list status-c{0}'.f(status.color), props.className)}>
                    <div className="max-w-100-percent txt-truncate">{status?.name}</div>
                </div>

                <div className="buttons flex-no-shrink">
                    <div className="btn-arrow"/>
                </div>
            </div>

            {props.showPopover &&
                <TaskStatusSelectorPopover
                    hidePopover     = {props.onHidePopover}
                    task            = {props.listItem.task}
                    workflow        = {_workflow}
                    onStatusSelect  = {props.onValueChange}
                    togglePopover   = {props.onHidePopover}
                    hint            = {true}
                    popoverPosition = {PopoverPosition.top()}
                    getTarget       = {()=>findDOMNode(refSelf.current)}
                />

                // <field.components.PopoverMenu {...props} parent={this} />
            }
        </div>
    )
}
